// src/components/ui/ConfirmModal.tsx
import React from "react";
import { GlassPanel } from "./GlassPanel";

export function ConfirmModal({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  busy = false,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1000] grid place-items-center bg-black/50 bg-opacity-50">
      <GlassPanel className="max-w-sm text-greyscale-1">
        <h4 className="subtitle-text">{title}</h4>
        {description ? <p className="">{description}</p> : null}
        <div className="flex justify-end gap-2">
          <button
            className="outlined-button"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>
          <button
            className="primary-button"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Processing…" : confirmLabel}
          </button>
        </div>
      </GlassPanel>{" "}
    </div>
  );
}
